module.exports = __webpack_public_path__ + "img/default_avater.efdf9446.png";